export default __webpack_public_path__ + "static/media/charger.05960091.jpg";